import request from '@/utils/request'

let GroupawardApi = {
    /*列表*/
    list(data) {
        return request._get('/shop/plus.groupaward.groupaward/index', data);
    },
    /*添加*/
    add(data) {
        return request._post('/shop/plus.groupaward.groupaward/add', data);
    },
    /*编辑*/
    edit(data) {
        return request._post('/shop/plus.groupaward.groupaward/edit', data);
    },
    /*删除*/
    del(data) {
        return request._post('/shop/plus.groupaward.groupaward/delete', data);
    },

}

export default GroupawardApi;



// WEBPACK FOOTER //
// ./src/api/groupaward.js